import styled from "styled-components";
import { LeftStars, RightStars, FriendListTopBg, NoImageUser } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	margin: 0;
	background-color: #F4F4F4;
	min-height: 100vh;
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
`;

export const OuterDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;

	padding: 16px;
	margin: 0 auto 10px;
	width: calc(100% - 32px);
	box-sizing: border-box;
	border-radius: 8px;
	background: #FFF;
`;

export const InfoText = styled.span`
	color: #2A2A2A;
	font-size: ${(props) => (props.isName !== true ? "14" : "14")};
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
	word-break: break-all;
`;

export const DateText = styled.span`
	text-align: right;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: 22px; /* 183.333% */
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	white-space: nowrap;
`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: column;
`;

export const IndexNumber = styled.div`
	color: #f9f9f9;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 7px;
`;

export const Number = styled.div`
	color: #2A2A2A;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; 
	margin-right: 6px;
`;

export const FriendListWrapper = styled.div`
`;

export const TitleDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;

	margin-bottom: 10px;
	height: 224px;
	width: 100% !important;
	background-image: url(${FriendListTopBg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: top;

	@media screen and (max-width: 350px) {
		height: 200px;
	}
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 5px;
	padding: 3px 0;
`;

export const LeftStarsGroup = styled(LeftStars)`
	position: absolute;
	left: 10px;
`;

export const RightStarsGroup = styled(RightStars)`
	position: absolute;
	right: 10px;
`;

export const Title = styled.p`
	color: #2A2A2A;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px; /* 150% */

	@media screen and (max-width: 425px) {
		font-size: 16px;
	}
`;

export const SubTitle = styled.p`
	background: var(--color-gold-gradient, linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%));
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px;
`;

export const NoFriendListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	height: 50vh;
`;

export const NoFriendText = styled.p`
	color: #2A2A2A;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 28px; /* 155.556% */
`;

export const UserIcon = styled.img.attrs({
	src: `${NoImageUser}`,
	alt: "no_img",
})`
	width: 40px;
	height: 40px;

	@media screen and (max-width: 340px) {
		width: 30px;
		height: 30px;
	}
`;

export const Desc = styled.div`
	color: #2A2A2A;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */

	width: calc(100% - 32px);
	padding: 6px 16px 16px 16px;

	@media screen and (max-width: 425px) {
		font-size: 14px;
	}
`
